import posthog from 'posthog-js';

/**
 * Capture edge function errors with detailed context
 */
export const captureEdgeFunctionError = (
  functionName: string,
  error: any,
  context?: Record<string, any>
) => {
  console.error(`Edge function error (${functionName}):`, error);
  
  if (posthog) {
    posthog.capture('edge_function_error', {
      function_name: functionName,
      error_message: error?.message || 'Unknown error',
      error_name: error?.name || 'Error',
      error_stack: error?.stack || null,
      status_code: error?.status || null,
      context: context || {},
      timestamp: new Date().toISOString(),
      url: window.location.href
    });
  }
};

/**
 * Capture generic application errors
 */
export const captureAppError = (
  errorType: string,
  error: any,
  context?: Record<string, any>
) => {
  console.error(`App error (${errorType}):`, error);
  
  if (posthog) {
    posthog.captureException(error, {
      error_type: errorType,
      context: context || {},
      timestamp: new Date().toISOString(),
      url: window.location.href
    });
  }
};

/**
 * Track non-200 response from Supabase functions
 */
export const trackSupabaseFunctionError = (
  functionName: string,
  response: any,
  requestData?: any
) => {
  if (posthog) {
    posthog.capture('supabase_function_non_200', {
      function_name: functionName,
      status_code: response?.status || null,
      error_data: response?.error || response?.data || null,
      request_data: requestData || {},
      timestamp: new Date().toISOString(),
      url: window.location.href
    });
  }
};
